import { render, staticRenderFns } from "./UnitTransfered.vue?vue&type=template&id=45a7b96e&"
import script from "./UnitTransfered.vue?vue&type=script&lang=ts&"
export * from "./UnitTransfered.vue?vue&type=script&lang=ts&"
import style0 from "./UnitTransfered.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
